<template>
  <div class="redirect">
    <div class="title">
      <h3>Đang chuyển trang, vui lòng đợi trong giây lát...</h3>
    </div>
    <div class="loading">
      <div class="el-icon-loading"></div>
    </div>
  </div>
</template>

<script>

  import authenService from "../../services/authenService";
  import VueCookies from 'vue-cookies';

  export default {

    name: "LogoutCallback",

    created() {
      this.removeToken();
    },

    methods: {

      removeToken() {
        authenService
          .removeToken()
          .then(() => {
            VueCookies.remove("IdHash");
            this.$router.replace({name: 'login'});
          });
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/login/LogoutCallback.vue